<!-- Start Footer Area -->

        <div class="portfolio-agency-banner pa-bg jarallax" data-jarallax='{"speed": 0.3}' style="height: 250px">
            
    <div class="container">
      
    </div>

    <div class="copyright-area" style="position: absolute; bottom: 0; width: 100%; color: white !important;">
            <div class="row align-items-center" style="color: white !important;">
                <div class="col-lg-12 col-sm-6 col-md-6" class="color" style="text-align: center;">
                    <p>Copyright @{{currentYear}} <a href="https://www.facebook.com" class="text-gray-600 ml-1"
                            target="_blank" rel="noopener noreferrer" >Kolagaon Gausia T.B.A.S Dakhil Madrasah</a>. All rights
                        reserved</p>
                </div>
                <div class="col-lg-12 col-sm-6 col-md-6" class="color" style="text-align: center;">
                    <p>Developed by <a href="https://deshuniversal.com/" class="text-gray-600 ml-1" target="_blank"
                            rel="noopener noreferrer" >Desh
                            Universal Pvt. Limited</a>
                </div>
            </div>
        </div>
        </div>

<!-- End Footer Area -->